module.exports = __webpack_public_path__ + "img/cash_nl500-1000.b39f2623.png";